<template>
  <div class="recipient-picker">
    <div class="recipient-chips">
      <span class="recipient-chip" v-for="user in selected" :key="user.id">
        <img v-if="user.avatar" :src="user.avatar" class="recipient-chip-avatar"/>
        <span class="recipient-chip-name">{{ user.username }}</span>
        <button type="button" class="recipient-chip-remove" @click="remove(user)" aria-label="Remove">&times;</button>
        <input type="hidden" name="message[recipient_ids][]" :value="user.id"/>
      </span>
      <input
        ref="input"
        class="recipient-input"
        type="text"
        autocomplete="off"
        v-model="query"
        v-if="selected.length < maxRecipients"
        @focus="open = true"
        @keydown.backspace="onBackspace"
        :placeholder="selected.length ? 'Add another…' : 'Search for people…'"
      />
      <span class="recipient-limit" v-else>Maximum {{ maxRecipients }} people per message</span>
    </div>

    <div class="recipient-dropdown" v-if="open && results.length">
      <div class="recipient-suggestion-label" v-if="!query">Friends &amp; recent</div>
      <button
        type="button"
        class="recipient-option"
        v-for="user in results"
        :key="user.id"
        @click="add(user)"
      >
        <span class="recipient-option-avatar">
          <img v-if="user.avatar" :src="user.avatar"/>
        </span>
        <span class="recipient-option-name">{{ user.username }}</span>
        <span class="recipient-option-friend" v-if="user.friend">friend</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'recipient-picker',
  data() {
    return {
      query: '',
      open: false,
      selected: [],
      raw: [],
      timer: null,
      // Mirrors Message::MAX_RECIPIENTS; the server enforces the real limit.
      maxRecipients: 5,
    }
  },
  computed: {
    // Hide already-selected users from the dropdown.
    results() {
      const chosen = new Set(this.selected.map((u) => u.id))
      return this.raw.filter((u) => !chosen.has(u.id))
    },
  },
  watch: {
    query() {
      this.open = true
      clearTimeout(this.timer)
      this.timer = setTimeout(() => this.fetch(), 200)
    },
  },
  mounted() {
    this.fetch()
    document.addEventListener('click', this.onOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.onOutside)
  },
  methods: {
    async fetch() {
      const res = await axios.get('/users/search.json', { params: { q: this.query } })
      this.raw = res.data || []
    },
    add(user) {
      if (this.selected.length >= this.maxRecipients) return
      this.selected.push(user)
      this.query = ''
      this.open = true
      this.$nextTick(() => this.$refs.input && this.$refs.input.focus())
    },
    remove(user) {
      this.selected = this.selected.filter((u) => u.id !== user.id)
    },
    onBackspace() {
      if (this.query === '' && this.selected.length) {
        this.selected.pop()
      }
    },
    onOutside(e) {
      if (!this.$el.contains(e.target)) this.open = false
    },
  },
}
</script>
